var exports = {
  "Ew": "MessageAttachments.module__forwardedContainer___SXo2aW",
  "iE": "MessageAttachments.module__forwardedBar___SXo2aW",
  "Q$": "MessageAttachments.module__forwardedContent___SXo2aW",
  "Sd": "MessageAttachments.module__forwardedHeader___SXo2aW",
  "Q_": "MessageAttachments.module__forwardedIcon___SXo2aW",
  "nQ": "MessageAttachments.module__forwardedLabel___SXo2aW",
  "KK": "MessageAttachments.module__attachmentsContainer___SXo2aW",
  "R$": "MessageAttachments.module__urlEmbedSpoiler___SXo2aW",
  "eb": "MessageAttachments.module__forwardedSourceButton___SXo2aW",
  "O_": "MessageAttachments.module__forwardedSourceLabel___SXo2aW",
  "wM": "MessageAttachments.module__forwardedSourceInfo___SXo2aW",
  "Lk": "MessageAttachments.module__forwardedSourceIcon___SXo2aW",
  "ZF": "MessageAttachments.module__forwardedSourceAvatar___SXo2aW",
  "qM": "MessageAttachments.module__forwardedSourceGuildIcon___SXo2aW",
  "T5": "MessageAttachments.module__forwardedSourceChevron___SXo2aW",
  "V0": "MessageAttachments.module__forwardedSourceName___SXo2aW",
  "ye": "MessageAttachments.module__stickersContainer___SXo2aW",
  "Bd": "MessageAttachments.module__stickerWrapper___SXo2aW",
  "Rq": "MessageAttachments.module__stickerWrapperInteractive___SXo2aW",
  "HF": "MessageAttachments.module__stickerImage___SXo2aW",
};

module.exports = exports;
